export default class AggregateProto {

    public data: any[]

    constructor(dataArray: any[]) {
        this.data = _.filter(dataArray, item=>!_.isNil(item) && !_.isNaN(item));
    }
}